var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-center scoped-new-texteditor" },
    [
      _c("x-test", { attrs: { id: "action::surveyTexts" } }),
      [
        _vm.languageChangerEnabled
          ? _c(
              "div",
              { staticClass: "row" },
              [
                _c("language-selector", {
                  attrs: {
                    elId: "texteditor",
                    aLanguages: _vm.$store.state.languages,
                    parentCurrentLanguage: _vm.$store.state.activeLanguage
                  },
                  on: { change: _vm.selectLanguage }
                })
              ],
              1
            )
          : _vm._e(),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "form-group col-md-4 col-sm-6" }, [
            _c("label", { attrs: { for: "surveyTitle" } }, [
              _vm._v(_vm._s(_vm._f("translate")("Survey title")))
            ]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.currentSurveyTitle,
                  expression: "currentSurveyTitle"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                name: "surveyls_title",
                id: "surveyTitle",
                required: "required"
              },
              domProps: { value: _vm.currentSurveyTitle },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.currentSurveyTitle = $event.target.value
                }
              }
            })
          ]),
          _vm.isNewSurvey
            ? _c("div", { staticClass: "form-group col-md-4 col-md-6" }, [
                _c(
                  "label",
                  {
                    staticClass: "control-label",
                    attrs: { for: "createsample" }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm._f("translate")(
                          "Create example question group and question?"
                        )
                      )
                    )
                  ]
                ),
                _vm._m(0)
              ])
            : _vm._e()
        ]),
        _c("div", { staticClass: "row" }, [
          _vm.isNewSurvey
            ? _c("div", { staticClass: "form-group col-md-4 col-md-6" }, [
                _c(
                  "label",
                  { staticClass: "control-label", attrs: { for: "language" } },
                  [_vm._v(_vm._s(_vm._f("translate")("Base language")))]
                ),
                _c(
                  "select",
                  {
                    staticClass: "form-control",
                    attrs: { id: "language", name: "language" }
                  },
                  _vm._l(_vm.languageList, function(language, key) {
                    return _c(
                      "option",
                      { key: key, domProps: { value: key } },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(language) +
                            "\n                    "
                        )
                      ]
                    )
                  }),
                  0
                )
              ])
            : _c("div", { staticClass: "form-group col-md-4 col-md-6" }, [
                _c(
                  "label",
                  { staticClass: "control-label", attrs: { for: "language" } },
                  [_vm._v(_vm._s(_vm._f("translate")("Base language")))]
                ),
                _c("div", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.languageName) +
                      "\n                "
                  )
                ])
              ]),
          _c("div", { staticClass: "form-group col-md-4 col-sm-6" }, [
            _c("label", { attrs: { for: "dateFormat" } }, [
              _vm._v(_vm._s(_vm._f("translate")("Date format")))
            ]),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentDateFormat,
                    expression: "currentDateFormat"
                  }
                ],
                staticClass: "form-control",
                attrs: { id: "dateFormat", name: "dateformat" },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.currentDateFormat = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              _vm._l(_vm.$store.state.dateFormatOptions, function(
                dateFormatOptionDescription,
                dateFormatOption
              ) {
                return _c(
                  "option",
                  {
                    key: dateFormatOption,
                    domProps: { value: dateFormatOption }
                  },
                  [_vm._v(" " + _vm._s(dateFormatOptionDescription) + " ")]
                )
              }),
              0
            )
          ]),
          _c("div", { staticClass: "form-group col-md-4 col-sm-12" }, [
            _c("label", { attrs: { for: "" } }, [
              _vm._v(_vm._s(_vm._f("translate")("Decimal mark")))
            ]),
            _c(
              "div",
              {
                staticClass: "fullystyled--radioButtons",
                attrs: { role: "group" }
              },
              [
                _c("div", { staticClass: "radioButtons--container" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currentDecimalDivider,
                        expression: "currentDecimalDivider"
                      }
                    ],
                    staticClass: "radio",
                    attrs: {
                      type: "radio",
                      id: "decimalDivider-0",
                      name: "numberformat"
                    },
                    domProps: {
                      value: 0,
                      checked: _vm._q(_vm.currentDecimalDivider, 0)
                    },
                    on: {
                      change: function($event) {
                        _vm.currentDecimalDivider = 0
                      }
                    }
                  }),
                  _c("label", { attrs: { for: "decimalDivider-0" } }, [
                    _vm._v(" " + _vm._s(_vm._f("translate")("Dot ")) + " (.) ")
                  ])
                ]),
                _c("div", { staticClass: "radioButtons--container" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currentDecimalDivider,
                        expression: "currentDecimalDivider"
                      }
                    ],
                    staticClass: "radio",
                    attrs: {
                      type: "radio",
                      id: "decimalDivider-1",
                      name: "numberformat"
                    },
                    domProps: {
                      value: 1,
                      checked: _vm._q(_vm.currentDecimalDivider, 1)
                    },
                    on: {
                      change: function($event) {
                        _vm.currentDecimalDivider = 1
                      }
                    }
                  }),
                  _c("label", { attrs: { for: "decimalDivider-1" } }, [
                    _vm._v(
                      " " + _vm._s(_vm._f("translate")("Comma ")) + " (,) "
                    )
                  ])
                ])
              ]
            )
          ])
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "form-group col-sm-4" }, [
            _c("label", { attrs: { for: "endUrl" } }, [
              _vm._v(_vm._s(_vm._f("translate")("End url")))
            ]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.currentEndUrl,
                  expression: "currentEndUrl"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text", name: "url", id: "endUrl" },
              domProps: { value: _vm.currentEndUrl },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.currentEndUrl = $event.target.value
                }
              }
            })
          ]),
          _c("div", { staticClass: "form-group col-sm-8" }, [
            _c("label", { attrs: { for: "endUrlDescription" } }, [
              _vm._v(_vm._s(_vm._f("translate")("URL description (link text)")))
            ]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.currentEndUrlDescription,
                  expression: "currentEndUrlDescription"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                name: "urldescrip",
                id: "endUrlDescription"
              },
              domProps: { value: _vm.currentEndUrlDescription },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.currentEndUrlDescription = $event.target.value
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "row scoped-editor-row" }, [
          _c(
            "div",
            {
              staticClass:
                "col-sm-12 ls-space margin top-5 bottom-5 scope-contains-ckeditor "
            },
            [
              _c("div", { staticClass: "ls-flex-row col-12" }, [
                _c("div", { staticClass: "ls-flex-item text-left" }, [
                  _c("label", {}, [
                    _vm._v(_vm._s(_vm._f("translate")("Description")) + ":")
                  ])
                ]),
                _vm.$store.state.permissions.update
                  ? _c("div", { staticClass: "ls-flex-item text-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-default btn-xs",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              _vm.descriptionSource = !_vm.descriptionSource
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-file-code-o" }),
                          _vm._v(
                            _vm._s(_vm._f("translate")("Toggle source mode"))
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ]),
              !_vm.$store.state.permissions.update
                ? _c("div", {
                    staticClass: "col-12",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.stripScripts(_vm.currentDescription)
                      )
                    }
                  })
                : _vm._e(),
              !_vm.descriptionSource && _vm.$store.state.permissions.update
                ? _c("lsckeditor", {
                    attrs: {
                      editor: _vm.descriptionEditorObject,
                      id: "descriptionEditor",
                      config: _vm.descriptionEditorConfig
                    },
                    on: {
                      error: _vm.CKErrorManagement,
                      focus: _vm.CKEventManagement
                    },
                    model: {
                      value: _vm.currentDescription,
                      callback: function($$v) {
                        _vm.currentDescription = $$v
                      },
                      expression: "currentDescription"
                    }
                  })
                : _vm._e(),
              _vm.descriptionSource && _vm.$store.state.permissions.update
                ? _c("aceeditor", {
                    attrs: {
                      id: "descriptionSource",
                      thisId: "currentDescriptionSourceEditor",
                      showLangSelector: false
                    },
                    model: {
                      value: _vm.currentDescription,
                      callback: function($$v) {
                        _vm.currentDescription = $$v
                      },
                      expression: "currentDescription"
                    }
                  })
                : _vm._e(),
              _vm.$store.state.permissions.update
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currentDescription,
                        expression: "currentDescription"
                      }
                    ],
                    attrs: { type: "hidden", name: "description" },
                    domProps: { value: _vm.currentDescription },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.currentDescription = $event.target.value
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row scoped-editor-row" }, [
          _c(
            "div",
            {
              staticClass:
                "col-sm-12 ls-space margin top-5 bottom-5 scope-contains-ckeditor "
            },
            [
              _c("div", { staticClass: "ls-flex-row col-12" }, [
                _c("div", { staticClass: "ls-flex-item text-left" }, [
                  _c("label", {}, [
                    _vm._v(_vm._s(_vm._f("translate")("Welcome")) + ":")
                  ])
                ]),
                _vm.$store.state.permissions.update
                  ? _c("div", { staticClass: "ls-flex-item text-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-default btn-xs",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              _vm.welcomeSource = !_vm.welcomeSource
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-file-code-o" }),
                          _vm._v(
                            _vm._s(_vm._f("translate")("Toggle source mode"))
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ]),
              !_vm.$store.state.permissions.update
                ? _c("div", {
                    staticClass: "col-12",
                    domProps: {
                      innerHTML: _vm._s(_vm.stripScripts(_vm.currentWelcome))
                    }
                  })
                : _vm._e(),
              !_vm.welcomeSource && _vm.$store.state.permissions.update
                ? _c("lsckeditor", {
                    attrs: {
                      editor: _vm.welcomeEditorObject,
                      id: "welcomeEditor",
                      config: _vm.welcomeEditorConfig
                    },
                    on: {
                      error: _vm.CKErrorManagement,
                      focus: _vm.CKEventManagement
                    },
                    model: {
                      value: _vm.currentWelcome,
                      callback: function($$v) {
                        _vm.currentWelcome = $$v
                      },
                      expression: "currentWelcome"
                    }
                  })
                : _vm._e(),
              _vm.welcomeSource && _vm.$store.state.permissions.update
                ? _c("aceeditor", {
                    attrs: {
                      thisId: "currentWelcomeSourceEditor",
                      showLangSelector: false
                    },
                    model: {
                      value: _vm.currentWelcome,
                      callback: function($$v) {
                        _vm.currentWelcome = $$v
                      },
                      expression: "currentWelcome"
                    }
                  })
                : _vm._e(),
              _vm.$store.state.permissions.update
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currentWelcome,
                        expression: "currentWelcome"
                      }
                    ],
                    attrs: { type: "hidden", name: "welcome" },
                    domProps: { value: _vm.currentWelcome },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.currentWelcome = $event.target.value
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row scoped-editor-row" }, [
          _c(
            "div",
            {
              staticClass:
                "col-sm-12 ls-space margin top-5 bottom-5 scope-contains-ckeditor "
            },
            [
              _c("div", { staticClass: "ls-flex-row col-12" }, [
                _c("div", { staticClass: "ls-flex-item text-left" }, [
                  _c("label", {}, [
                    _vm._v(_vm._s(_vm._f("translate")("End message")) + ":")
                  ])
                ]),
                _vm.$store.state.permissions.update
                  ? _c("div", { staticClass: "ls-flex-item text-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-default btn-xs",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              _vm.endTextSource = !_vm.endTextSource
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-file-code-o" }),
                          _vm._v(
                            _vm._s(_vm._f("translate")("Toggle source mode"))
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ]),
              !_vm.$store.state.permissions.update
                ? _c("div", {
                    staticClass: "col-12",
                    domProps: {
                      innerHTML: _vm._s(_vm.stripScripts(_vm.currentEndText))
                    }
                  })
                : _vm._e(),
              !_vm.endTextSource && _vm.$store.state.permissions.update
                ? _c("lsckeditor", {
                    attrs: {
                      editor: _vm.endTextEditorObject,
                      id: "endTextEditor",
                      config: _vm.endTextEditorConfig
                    },
                    on: {
                      error: _vm.CKErrorManagement,
                      focus: _vm.CKEventManagement
                    },
                    model: {
                      value: _vm.currentEndText,
                      callback: function($$v) {
                        _vm.currentEndText = $$v
                      },
                      expression: "currentEndText"
                    }
                  })
                : _vm._e(),
              _vm.endTextSource && _vm.$store.state.permissions.update
                ? _c("aceeditor", {
                    attrs: {
                      thisId: "currentEndTextSourceEditor",
                      showLangSelector: false
                    },
                    model: {
                      value: _vm.currentEndText,
                      callback: function($$v) {
                        _vm.currentEndText = $$v
                      },
                      expression: "currentEndText"
                    }
                  })
                : _vm._e(),
              _vm.$store.state.permissions.update
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currentEndText,
                        expression: "currentEndText"
                      }
                    ],
                    attrs: { type: "hidden", name: "endtext" },
                    domProps: { value: _vm.currentEndText },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.currentEndText = $event.target.value
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ],
      _vm.loading
        ? _c(
            "div",
            [_c("loader-widget", { attrs: { id: "textelementsloader" } })],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("input", { attrs: { type: "checkbox", name: "createsample" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }